'use client'
import { Table, TableRow, TableHeader, TableCell } from "@/components/ui";
import React, { useEffect, useState } from "react";
import { getUserLogs } from "@/app/api";
import { LogsType } from "@/types";

export function UserLogs({ id }: { id: string; }) {
    const [logsData, setLogsData] = useState<LogsType[]>([])

    useEffect(() => {
        const fetchUserLog = async () => {
            try {
                const response = await getUserLogs(id)
                if (response !== null && Array.isArray(response)) {
                    setLogsData(response);
                } else {
                    setLogsData([]);
                }
            } catch (e) {
                console.log('Não foi possível buscar os logs: ', e)
            }
        }

        fetchUserLog()
    }, [id]);

    const logs = logsData || []

    return (
        <div className="p-8">
            <div className="hidden md:flex">
                <Table>
                    <thead>
                        <TableRow>
                            <TableHeader colSpan={3}>Observação</TableHeader>
                            <TableHeader colSpan={2}>Data</TableHeader>
                        </TableRow>
                    </thead>
                    <tbody>
                        {logs.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={5} className="text-center">
                                    Não existem logs para esse usuário.
                                </TableCell>
                            </TableRow>
                        ) : (logs.map((log) => (
                            <TableRow key={log.id}>
                                <TableCell colSpan={3}>{log.observation}</TableCell>
                                <TableCell colSpan={2}>{new Date(log.createdAt).toLocaleDateString()}</TableCell>
                            </TableRow>
                        ))
                        )
                        }
                    </tbody>

                </Table>
            </div>

            <div className="flex md:hidden">
                <Table>
                    <tbody>
                        {logs.length === 0 ? (
                            <TableRow>
                                <TableCell className="text-center">
                                    Não existem logs para esse usuário.
                                </TableCell>
                            </TableRow>
                        ) : (logs.map((log) => (
                            <TableRow key={log.id}>
                                <TableHeader>Observação</TableHeader>
                                <TableCell>{log.observation}</TableCell>
                                <TableHeader>Data</TableHeader>
                                <TableCell>{new Date(log.createdAt).toLocaleDateString()}</TableCell>
                                <TableCell className="border-t-2 min-w-40 border-ochre_accent" />
                            </TableRow>
                        ))
                        )
                        }
                    </tbody>
                </Table>
            </div>
        </div>
    )
}